import { Editor, IAllProps } from "@tinymce/tinymce-react";
import { TinyMCERecorderWrapper } from "../../../plugins/tinymce-recordrtc";

export const CustomEditor = ({ value, onEditorChange, id, disabled }: any) => {
  const editorConfig: IAllProps["init"] = {
    height: 300,
    menubar: true,
    // Load external plugins
    external_plugins: {
      audiorecorder: '/libs/tinymce/plugins/audiorecorder/plugin.min.js',
      videorecorder: '/libs/tinymce/plugins/videorecorder/plugin.min.js',
      mathjax: '/libs/tinymce/plugins/mathjax/plugin.js',
    },
    plugins: [
      "advlist",
      "autolink",
      "lists",
      "link",
      "image",
      "charmap",
      "preview",
      "anchor",
      "searchreplace",
      "visualblocks",
      "code",
      "fullscreen",
      "insertdatetime",
      "media",
      "table",
      "code",
      "help",
      "wordcount",
      "emoticons",
      "nonbreaking",
      "quickbars",
      "searchreplace",
      "visualchars",
      "directionality",
      "audiorecorder",
      "videorecorder",
      "mathjax",
    ],
    toolbar:
      "undo redo | formatselect | " +
      "bold italic underline | " +
      "alignleft aligncenter alignright alignjustify | " +
      "bullist numlist outdent indent | " +
      "link image media table emoticons hr | " +
      "videorecorder audiorecorder | mathjax | " +
      "code fullscreen help",
    toolbar_mode: "sliding",
    contextmenu: "link image table",
    image_advtab: true,
    link_context_toolbar: true,
    paste_data_images: true,
    browser_spellcheck: true,
    file_picker_types: "file image media",
    promotion: false,
    branding: false,
    content_style:
      'body { font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial; font-size: 14px; }',
    quickbars_selection_toolbar:
      "bold italic underline | formatselect | quicklink blockquote",
    quickbars_insert_toolbar: "image media table hr mathjax",
    skin: "oxide",
    icons: "default",
    statusbar: false,
  };
  return (
    <>
      <Editor
        // apiKey="5lyrkm07icutq6j3u6fu37njdh91b27h27i0lxif23yss956"
        tinymceScriptSrc="/libs/tinymce/tinymce.min.js"
        value={value}
        init={editorConfig}
        onEditorChange={onEditorChange}
        id={id}
        licenseKey="gpl"
        disabled={disabled}
      />
      <TinyMCERecorderWrapper />
    </>
  );
};
